import PageTemplate from "../../components/feature/PageTemplate";
import { locationsContent } from "../../mocks/locations-content";

export default function LocationsPage() {
  return <PageTemplate content={locationsContent} />;
}
